import { getCheckoutDetails } from "./endpoints/stripe.service";
import env from "./env";
const server = env.apiLink;

const api = {
  // auth
  login: `user/login`,
  token: `user/login/token`,
  linkedToken: `user/login/linked-token`,
  microsoftLoginUrl: `user/login/microsoft/url`,
  microsoftLogin: `user/login/microsoft`,
  signup: `user/signup`,
  verifyEmail: "user/verify-email",
  resendOtpverifyEmail: "user/resend-verify-email",
  updateDisableStatus: "user/update-disable-status",
  changePassword: "user/change-password",
  recruiterAddCompany: "recruiter/add-company",
  generateUserNames: "user/generate-usernames",
  updateUserName: "user/update-username",
  linkAccount: "user/link-account",
  updatePrivacy: "/contact/update-privacy-setting",
  updateRequestPrivacySetting: "/contact/update-request-privacy-setting",
  updateUserProfile: "/user/update-profile",

  //payment
  pendingEarning: "payment/referral-pending-earning",
  potentialEarning: "payment/referral-potential-earning",
  totalEarningAndWihdraw: "payment/referral-total-withdrawal-earning",
  withdrawalHistories: "payment/referral-withdrawal-histories",
  jobPostingFee: "payment/job-posting-referral-fees-plan",
  paymentRefund: "payment/create-payment-refund",

  // stripe
  getAccountDetails: "payment/account-details",
  getStripeAccountDetails: "payment/stripe-account-details",
  createStripeAccountSession: "payment/create-stripe-account-session",
  createCheckoutSession: "payment/create-checkout-session",
  createCardPaymentIntent: "payment/create-card-payment-intent",
  createSetupIntent: "payment/create-setup-intent",
  createBankPaymentIntent: "payment/create-bank-payment-intent",
  getReferrals: "recruiter/referrals",
  createCustomer: "payment/create-customer",
  addCardPaymentMethod: "payment/add-card",
  addBankDetails: "payment/attach-bank",
  getBankLists: "payment/banks",
  makeDefaultBank: "payment/make-default",
  updateBankDetails: "payment/update-bank",
  fetchBankDetails: "payment/bank-details",
  deleteBank: "payment/bank",
  getBalanceDetails: "payment/balance",
  withDrawBalance: "payment/withdrawl",
  fetchPaymentMethods: "payment/payment-methods",
  addCustomerBankAccount: "payment/add-bank-account",
  deletePaymentMethod: "payment/payment-method",
  setDefaultPaymentMethod: "payment/set-default",
  getCheckoutDetails: "payment/checkout-details",
  createPaymentHistory: "payment/create-payment-history",
  getPaymentHistories: "payment/payment-histories",
  getReferralPaymentHistories: "payment/referral-payment-histories",
  createReferralTransaction: "payment/create-referral-transaction",
  getPaymentHistoryDetails: "payment/details",
  getJobPostingPriceDetails: "payment/job-posting-plan",
  createPaymentIntent: "payment/create-payment-intent",
  fetchSubscriptionPlansByType: "payment/subscription-plans-by-type",
  createSubscription: "subscription/create-subscription",
  getActiveSubscription: "subscription/active-subscription",
  cancelSubscription: "subscription/cancel-subscription",
  undoCancel: "subscription/undo-cancel",
  changeSubscription: "subscription/change-subscription",
  receiptUserDetails: "payment/user-details",

  //candidate
  getCandidates: "contact/get-candidates",
  getRegisterCandidates: "contact/registered-candidates",
  getCandidateAssessment: "contact/candidate-assessments",
  getCandidateDetails: "contact/candidate-details",
  addCandidate: "contact/add-candidate",
  updateCandidate: "contact/update-candidate",
  updateCandidateProfile: "contact/update-candidate",
  deleteCandidate: "contact/delete-candidate",
  addExperience: "contact/add-experience",
  updateExperience: "contact/update-experience",
  getExperienceList: "contact/experiences",
  getExperience: "contact/get-experience",
  deleteExperience: "contact/delete-experience",
  getContactSkills: "contact/candidate-skills",
  getRestrictedCandidate: "contact/restricted-candidate-details",
  getCandidateAppliedJobs: "/job/candidate-jobs",
  getReferral: "/contact/get-referral",
  getReferralRequests: "/contact/referral-requests",
  addNewReferral: "/contact/resend-request",
  deleteReferral: "/contact/request/delete",
  removeReferral: "/contact/remove-referral",
  finalConfirmation: "/contact/final-confirmation",
  getMessagesList: "/job/message/lists",
  sendMessage: "/job/message",
  // getCandidateMatchedJobs: "/referral/contact-matches-jobs",
  getCandidateMatchedJobs: "/contact/matched-jobs",
  markUnmarkFavoriteMatchedJobs: "/contact/job-match/mark-unmark/favorite",
  contactAspirationAdd: "/contact/aspiration/add",
  getContactAspirationAdd: "/contact/aspiration/details",
  updateContactAspiration: "/contact/aspiration",

  //company
  getCompany: "",
  companyList: "company/lists",
  addCompany: "company/add",
  updateCompany: "company/update",
  deleteCompany: "company/delete",

  //company contact
  getCompanyContact: "company/contacts",
  addCompanyContact: "company/add-contact",
  deleteCompanyContact: "company/delete-contact",
  updateCompanyContact: "company/update-contact",

  createRecruiterProfile: `recruiter-profile`,
  resetPassword: `auth/reset-password`,
  registerEmailVerify: `auth/email-verify`,
  forgotPassword: `user/forgot-password`,
  forgotPasswordVerify: `user/forgot-password/verify`,
  resetForgotPassword: `user/reset-forgot-password`,

  //assessment
  listAssessment: `assessment/lists`,
  createAssessment: `assessment/create-assessment`,
  deleteAssessment: `assessment/delete-assessment`,
  assessmentDetails: `assessment/details`,
  updateAssessment: `assessment/update-assessment`,
  deleteAssessment: `assessment/delete-assessment`,
  createCompany: `assessment/create-company`,
  sendAssessment: `assessment/send-assessment`,

  //assessment section
  createSection: `assessment/create-section`,
  updateSection: `assessment/update-section`,
  getSection: `assessment/section`,
  updateSection: `assessment/update-section`,
  deleteSection: `assessment/delete-section`,

  //assessment question
  updateQuestion: `assessment/update-question`,
  createQuestion: `assessment/create-question`,
  getQuestionBySectionId: `assessment/question`,
  updateQuestion: `assessment/update-question`,
  deleteQuestion: `assessment/delete-question`,

  //Job
  getJobList: "job/lists",
  jobListViewByCandidate: "job/lists/applications",
  jobListByCompany: (hiringCompanyId) =>
    `recruiter/hiring-company/${hiringCompanyId}/jobs`,
  getJobDetails: "job/details",
  addJob: "job/add",
  shareJob: "job/share-job",
  verifyJob: "user/verify-share-job",
  verifyJobStatus: "user/share-job-verify-status",
  updateJob: "job/update",
  deleteJob: "job/delete/",
  publishUnpublish: "job/publish-unpublish",
  applyJob: "job/apply-job",
  applicantList: "job/applicants/lists",
  jobMessage: "job/message",
  jobMessageList: "job/message/lists",
  jobMembersProfile: "job/get-members-profile",
  jobAddTracker: "job/add-tracker",
  jobGetTracker: "job/get-trackers",
  jobSubmission: "job/submission-queue",
  jobSubmissionQueueSubmit: (jobId) => `job/${jobId}/submission-queue/submit`,
  jobUpdateApplicant: "job/update-applicant",
  unseenMessageCount: "job/get-unseen-message-count",
  updateMessageSeen: "job/messages/seen",
  matchJobSkils: "/job/match-job-skills",
  jobSeen: "/job/seen",
  contactMatches: "/job/contacts-matches",
  confirmExclusiveRepresentation: "/job/confirm-exclusive-representation",

  // Education or Certificate
  addCertificateOrEducation: "contact/add-certificate",
  updateCertificateOrEducation: "contact/update-certificate",
  getCertificateOrEducation: "contact/certificates",

  //skill
  addSkill: "skill/add",
  updateSkill: "skill/update",
  deleteSkill: "skill/delete/",
  skillSearch: "skill/search",
  getSkillIndividualPercentage: "skill/get-individual-percentages",
  listSkill: "skill/lists",

  getMatchedCandidate: "skill/get-matched-candidates",

  //images
  profileImage: "medias/images-direct-url",

  //recruiter
  accountMembers: "recruiter/members",
  recruiterInvite: "recruiter/invite",
  recruiterInviteList: "recruiter/invite/list",
  recruiterInviteSsoToggle: "recruiter/invite/sso",
  recruiterDetail: "recruiter/details",
  recruiterProfileUpdate: "recruiter/update-profile",
  approvalRequest: "recruiter/update-request",
  suspendAccount: "recruiter/suspend-account",
  userAdmin: "recruiter/make-admin",
  hiringCompanyWithJobCounts: "recruiter/hiring-companies",
  deleteRecruiterAccount: `user/deactivate`,

  //referral
  referralProfileUpdate: "referral/update-profile",
  referralContacts: "referral/contacts",
  referralRecruiterContacts: "referral/recruiter-agents",
  referralMatchedContacts: "referral/matched-contacts",
  referralMatchedContactDetails: "referral/matched-contact-details",
  inviteUserEmail: "referral/invite",
  referralMatchedJobs: "referral/contact-matches-jobs",
  verifyReferralInvite: "user/verify-invitee",
  inviteReferral: "user/invite-referral",
  contactMatchesJob: "referral/contacts-matches-jobs",
  contactMatchesSkills: "referral/contact-matches-skills",
  getReferralTrackers: "job/get-referral-trackers",
  updateReferral: "/user/update-referral",
  referralRequestAction: "/referral/request-action",
  contactMatchesJobs: "/referral/contact-matches-jobs",
  getJobMessagesList: "/job/message/lists",
  sendJobMessage: "/job/message",
  requestDetailAccess: "/referral/request-detail-access",

  //notificaiton
  getNotificationList: "/job/notifications/lists",
  updateNotification: "/job/notification/update",
  getCalendarUnreadCount: "/job/notifications/calendar/unread-count",
  getNotificationUnreadCount: "/job/notifications/unread-count",
  acitvityTracker: "/activity-tracker/lists",

  //interview
  createInterview: "interview/create",
  updateInterview: "interview/update",
  deleteInterview: "interview/delete",
  listInterviews: "interview/lists",
  listRecruiterInterview: "interview/recruiter-lists",
  listCandidateInterview: "interview/lists",
  getInterviewDetails: "interview",
  acceptInterview: "interview/accept-invitation",
  confirmInterview: "interview/confirm-interview",
  candidateAutoComplete: "interview/autocomplete-candidates",
  jobAutoComplete: "interview/autocomplete-jobs",
  listAvailabilities: "interview/availability-list",
  addAvailability: "interview/add-availability",
  deleteAvailability: "interview/availability-delete",
  confirmSlotAvailability: "interview/update-slot-availability",
  forwardInterview: "interview/forward-invitation",
  sendInterviewInvite: "interview/send-invite",
  readInterview: (interviewId) => `interview/${interviewId}/read`,

  // Hiring company
  hiringCompanyMembers: "/hiring-company/members",
  hiringCompanyDetails: "/hiring-company/company-details",
  inviteHiringStaff: "/hiring-company/invite-staff",
  updateStaffRequest: "/hiring-company/update-request",
  jobRequirement: {
    list: "/requirement/lists",
    byId: "/requirement",
    byRecruiterId: "/requirement/recruiter/submitted-requirements",
    add: "/requirement/add",
    update: "/requirement/update",
    submittedCandidates: "/submitted-candidates",
    partnerAgencies: "/requirement/lists/partner-agencies",
    invitationHiringCompany: "/recruiter/invitations/hiring-company",
    searchHiringCompany: "/recruiter/hiring-company",
    grantAccess: "/requirement/grant-access",
    recruitersAvailableToInvite: "/requirement/recruiters/available-to-invite",
    sendPartnerRequest: "/requirement/send-partner-request",
    skills: {
      add: "/requirement/skill/add",
      update: "/requirement/skill/update",
    },
    userProfile: "requirement/user-profile",
  },

  // pdf generation
  generatePdf: "generate-pdf",
};

export default api;
